export var ChangeSlider;
(function (ChangeSlider) {
    ChangeSlider["PERIOD"] = "period";
    ChangeSlider["SUM"] = "sum";
    ChangeSlider["PERVIP"] = "perVip";
    ChangeSlider["CUSTOM"] = "CUSTOM";
})(ChangeSlider || (ChangeSlider = {}));
export var CalcRequestPlace;
(function (CalcRequestPlace) {
    CalcRequestPlace["ONLINE"] = "ONLINE";
    CalcRequestPlace["PUBLIC"] = "PUBLIC";
    CalcRequestPlace["STEP32"] = "STEP32";
    CalcRequestPlace["STEP232"] = "STEP232";
    CalcRequestPlace["AUTO"] = "AUTO";
    CalcRequestPlace["PUBLIC_AUTO"] = "PUBLIC_AUTO";
})(CalcRequestPlace || (CalcRequestPlace = {}));
export var Rounded;
(function (Rounded) {
    Rounded["SM"] = "10px";
    Rounded["MD"] = "16px";
    Rounded["CIRCLE"] = "100%";
})(Rounded || (Rounded = {}));
export var InsuranceType;
(function (InsuranceType) {
    InsuranceType["LIFE"] = "LIFE";
    InsuranceType["IPR"] = "IPR";
})(InsuranceType || (InsuranceType = {}));
export var ProductsType;
(function (ProductsType) {
    ProductsType["all"] = "all";
    ProductsType["default"] = "default";
    ProductsType["auto"] = "auto";
})(ProductsType || (ProductsType = {}));
export var ProductsFor;
(function (ProductsFor) {
    ProductsFor["mainPageCalculator"] = "calc_main";
    ProductsFor["step32Calculator"] = "calc_step32";
})(ProductsFor || (ProductsFor = {}));
export var SelectorTypesEnum;
(function (SelectorTypesEnum) {
    SelectorTypesEnum["SUM"] = "sum";
    SelectorTypesEnum["TERM"] = "term";
    SelectorTypesEnum["TEXT"] = "text";
})(SelectorTypesEnum || (SelectorTypesEnum = {}));
